<template>
  <div class="f-paizhao">
    <img  v-if="invoiceImageData.base64" class="background-img" :src="invoiceImageData.base64">
    <van-popup v-model="overlayVisible" :close-on-click-overlay="false" style="background: transparent" class="content-wrapper">
      <div class="content invoice-upload-wrapper">
        <div class="title">
          <div class="title1">
            <div>请确认发票信息是否与票面相符</div>
          </div>
          <van-icon color="#fff" name="cross" @click="goBack" />
        </div>
        <van-cell-group>
          <van-field
            label="票据类型"
            v-model="invoiceInfo.invoiceTypeName"
            readonly="readonly"
            required
          />
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.purchaserName">
          <van-field
            label="购方名称"
            v-model="editData.purchaserName"
            required
          />
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.sellerName">
          <van-field
            label="销方名称"
            v-model="editData.sellerName"
            required
          />
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.invoiceCode">
          <van-field
            label="发票代码"
            v-model="editData.invoiceCode"
            required
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            label="发票号码"
            v-model="editData.invoiceNo"
            required
          />
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.passengerName">
          <van-field
            label="乘机人姓名"
            v-model="editData.passengerName"
            required
          />
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.mileage">
          <van-field
            label="里程"
            v-model="editData.mileage"
            required
          />
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.getOnDate">
          <van-field
            label="乘车日期"
            v-model="editData.getOnDate"
            required
          />
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.trainNumber">
          <van-field
            label="车次"
            v-model="editData.trainNumber"
            required
          />
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.seat">
          <van-field
            label="座位类型"
            v-model="editData.seat"
            required
          />
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.stationGetOn">
          <van-field
            label="上车车站"
            v-model="editData.stationGetOn"
            required
          />
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.stationGetOff">
          <van-field
            label="下车车站"
            v-model="editData.stationGetOff"
            required
          />
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.drewDate && invoiceInfo.invoiceType === '01' || invoiceInfo.invoiceType === '04' || invoiceInfo.invoiceType === '10' || invoiceInfo.invoiceType === '11' || invoiceInfo.invoiceType === '202'">
          <van-field
            label="开票日期"
            v-model="editData.drewDate"
            required
          />
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.amountWithTax">
          <van-field
            label="金额（含税）"
            v-model="editData.amountWithTax"
            required
          />
        </van-cell-group>
         <van-cell-group v-show="invoiceInfo.fare">
          <van-field
            label="票价"
            v-model="editData.fare"
            required
          />
        </van-cell-group>
         <van-cell-group v-show="invoiceInfo.totalTax">
          <van-field
            label="税费"
            v-model="editData.totalTax"
            required
          />
        </van-cell-group>
        <van-cell-group
          v-show="invoiceInfo.amount"
        >
          <van-field
            label="不含税金额"
            v-model="editData.amount"
            required
          />
        </van-cell-group>
        <van-cell-group
          v-show="invoiceInfo.checkCode"
        >
          <van-field
            label="校验码"
            v-model="editData.checkCode"
            required
          />
        </van-cell-group>
        <div class="f-upload">
          <van-button type="info" @click="submit">提交</van-button>
          <van-button type="info" @click="save">保存</van-button>
        </div>
      </div>
    </van-popup>
    <MyActionSheet
      :columns="companyNameList"
      :visible="companyData.visible"
      @cancel="companyData.visible = false"
      @confirm="onCompanyConfirm"
      type="companyList"
    />
  </div>
</template>

<script>
import { CellGroup, Button, Toast, Notify, Popup, Icon, Field, Cell } from 'vant'
import MyActionSheet from '@components/OfficialAccount/ActionSheet'
import { officialAccountRequest } from '@services'
import UploadService from '@services/UploadService'
import { deepCopy } from '@utils/basicUtil'

export default {
  data: () => ({
    imgData: '',
    overlayVisible: false,
    invoiceInfo: {},
    invoiceType: '01',
    submitType: '',
    submitData: {
      officialAccountId: '',
      imagePath: ''
    },
    companyData: {
      visible: false,
      companyId: ''
    },
    editData: {}
  }),
  computed: {
    invoiceImageData: (vm) => {
      return vm.$store.state.officialAccount.invoiceImageData
    },
    userInfo: (vm) => {
      return vm.$store.state.officialAccount.userInfo
    },
    companyNameList () {
      return this.$store.state.officialAccount.companyNameList
    },
    companyList () {
      return this.$store.state.officialAccount.companyList
    }
  },
  watch: {
    userInfo () {
      if (this.userInfo.id) {
        this.submitData.officialAccountId = this.userInfo.id
      }
    }
  },
  mounted () {
    this.discern()
  },
  methods: {
    async discern () {
      Toast.loading({
        message: '发票识别中...',
        forbidClick: true,
        duration: 0
      })
      this.invoiceInfo = {}
      const data = await officialAccountRequest.weChat.discern({ currentUserMobile: this.userInfo.mobile, imageData: this.invoiceImageData.base64, officialAccountId: this.submitData.officialAccountId })
      if (data.success) {
        if (data.result.vatFlag === '1') {
          this.nonVatTicket(data.result.nonVatTicketDiscern)
          this.invoiceType = 'nonVat'
        } else {
          this.vatTicket(data.result.vatTicketDiscern)
          this.invoiceType = 'vat'
        }
      } else {
        Notify({ type: 'danger', message: '发票识别出错' })
        this.goBack()
      }
      this.overlayVisible = true
      Toast.clear({
        clearAll: true
      })
    },
    uploadImage () {
      Toast.loading({
        message: '发票上传中...',
        forbidClick: true,
        duration: 0
      })
      return new Promise(async (resolve, reject) => {
        try {
          const data = await UploadService(this.invoiceImageData.file, true)

          if (data.success) {
            this.submitData.imagePath = data.url
            resolve()
          }
        } catch (e) {
          alert(e)
        }
      })
    },
    vatTicket (data) {
      let invoiceInfo = data
      switch (data.invoiceType) {
        case '01':
          invoiceInfo.invoiceTypeName = '增值税专用发票'
          break
        case '04':
          invoiceInfo.invoiceTypeName = '增值税普通发票'
          break
        case '10':
          invoiceInfo.invoiceTypeName = '增值税电子发票'
          break
        case '11':
          invoiceInfo.invoiceTypeName = '增值税卷式发票'
          break
        default:
          break
      }
      this.invoiceInfo = invoiceInfo
      this.editData = deepCopy(invoiceInfo)
    },
    nonVatTicket (data) {
      let invoiceInfo = data
      switch (data.invoiceType) {
        case '202':
          invoiceInfo.invoiceTypeName = '航空客票行程单'
          break
        case '200':
          invoiceInfo.invoiceTypeName = '定额发票'
          break
        case '201':
          invoiceInfo.invoiceTypeName = '火车票'
          break
        case '207':
          invoiceInfo.invoiceTypeName = '出租车发票'
          break
        case '11':
          invoiceInfo.invoiceTypeName = '增值税卷式发票'
          break
        default:
          break
      }
      this.invoiceInfo = invoiceInfo
      this.editData = deepCopy(invoiceInfo)
    },
    submit () {
      this.submitType = 'saveAndCommit'
      if (this.companyList.length > 1) {
        this.showCompanyPicker()
      } else {
        this.submitData.officialAccountId = this.companyList[0].id
        this.saveAndCommit()
      }
    },
    async save () {
      await this.uploadImage()
      this.submitType = 'save'
      this.submitData.officialAccountId = this.companyList[0].id
      if (this.invoiceType === 'nonVat') {
        this.nonVatSave()
      } else {
        this.vatSave()
      }
    },
    showCompanyPicker () {
      this.companyData.visible = true
    },
    onCompanyConfirm (data) {
      this.companyData.visible = false
      this.submitData.officialAccountId = data.value.id
      this.saveAndCommit()
    },
    findCompany (companyName) {
      for (let i = 0; i < this.companyList.length; i++) {
        if (this.companyList[i].companyName === companyName) {
          return this.companyList[i]
        }
      }
    },
    async saveAndCommit () {
      await this.uploadImage()
      if (this.invoiceType === 'nonVat') {
        this.nonVatSaveAndCommit()
      } else {
        this.vatSaveAndCommit()
      }
    },
    async nonVatSaveAndCommit () {
      let postData = { ...this.submitData, ticketInfo: { ...this.editData } }

      const data = await officialAccountRequest.weChat.nonVatSaveAndCommit(postData)

      if (data.success) {
        this.closeLoading()
      } else {
        this.uploadError(data.message)
      }
    },
    async nonVatSave () {
      let postData = { ...this.submitData, ticketInfo: { ...this.editData } }

      const data = await officialAccountRequest.weChat.nonVatSave(postData)

      if (data.success) {
        this.closeLoading()
      } else {
        this.uploadError(data.message)
      }
    },
    async vatSaveAndCommit () {
      let postData = { ...this.submitData, ticketInfo: { ...this.editData } }

      const data = await officialAccountRequest.weChat.vatSaveAndCommit(postData)

      if (data.success) {
        this.closeLoading()
      } else {
        this.uploadError(data.message)
      }
    },
    async vatSave () {
      let postData = { ...this.submitData, ticketInfo: { ...this.editData } }

      const data = await officialAccountRequest.weChat.vatSave(postData)

      if (data.success) {
        this.closeLoading()
      } else {
        this.uploadError(data.message)
      }
    },
    uploadError (message) {
      Toast.clear({
        clearAll: true
      })
      Notify({ type: 'danger', message })
    },
    closeLoading () {
      Toast.clear({
        clearAll: true
      })
      Notify({ type: 'success', message: '完成上传' })
      this.goBack()
    },
    goBack () {
      this.$router.push('/official-account/manager')
    }
  },
  components: {
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Notify.name]: Notify,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    MyActionSheet
  }
}
</script>

<style lang="less" scoped>
  .f-paizhao {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    background-size: cover;
    position: relative;
    background: #EDF2F6;
  }
  .background-img {
    height: auto;
    width: 100%;
    position: absolute;
    top:0;
    left: 0;
    z-index: 1;
  }
  .content {
    width: 80vw;
    .title {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      height: 100%;
      .title1 {
        display: flex;
        justify-content: center;
        flex-direction: column;
        height: 100%;
        margin-bottom: 30px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(255,255,255,1);
      }
      .font {
        width: 50px;
        height: 45px;
        opacity: 0.8;
        color: #DEDEDE;
        margin-bottom: 40px;
      }
    }
    .van-cell-group {
      background: black;
      border: 1px solid #fff;
      margin-bottom: 4px;
      .van-cell {
        background: transparent;
        color: #AEAEAE !important;
        overflow: visible;
        .van-cell__value {
          overflow: visible;
          color: #AEAEAE !important;
          .van-field__body {
            color: #AEAEAE !important;
            .van-field__control {
              color: #AEAEAE !important;
            }
          }
        }
      }
    }
  }
  .f-upload {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .upload {
    line-height: 60px;
    background: #4573de;
    color: white;
    height: 80px;
    width: 60%;
    border-radius: 12px;
    font-size: 0.68267rem;
  }
  .overlay {
    background-color: rgba(0,0,0,.4)
  }
  .f-view {
    width: 80vw;
    height: 60vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    background-color: rgba(255,255,255,1);
  }
  .text {
    margin-top: 121px;
    margin-left: 170px;
    margin-right: 170px;
    font-size: 36px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  .message1 {
    margin: 35px 70px 0 70px;
    font-size: 26px;
    line-height: 50px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
  }
  .message2 {
    margin: 0 70px 70px 70px;
    font-size: 26px;
    line-height: 50px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
  }
  .view {
    width: 265px;
    height: 65px;
    line-height: 50px;
    margin-left: 160px;
    margin-right: 160px;
    margin-bottom: 58px;
    background: rgba(65,136,254,1);
    color: white;
    border-radius: 5px;
    font-size: 26px;
    font-weight: 500;
  }
  .img-invoice{
    display:block;
    width:100%;
  }
</style>
